import { Auth0Context, type Auth0ContextInterface } from '@auth0/auth0-react';
import type { PropsWithChildren } from 'react';

// Cast rather than annotate: auth0-react v2.19 added several members
// (token exchange, account connection) we don't need for the local dev mock.
const mockAuth0Context = {
  isAuthenticated: true,
  isLoading: false,
  user: {
    email: 'dev@localhost',
    name: 'Local Dev User',
    granular_organization: {
      country_code: 'GB',
      name: 'Local Dev Org',
      timezone: 'Europe/London',
      type: 'supplier',
    },
  },
  getAccessTokenSilently: (() => Promise.resolve('dev-token')) as Auth0ContextInterface['getAccessTokenSilently'],
  getAccessTokenWithPopup: async () => 'dev-token',
  getIdTokenClaims: async () => undefined,
  loginWithRedirect: async () => {},
  loginWithPopup: async () => {},
  logout: async () => {},
  handleRedirectCallback: (async () => ({ appState: {} })) as Auth0ContextInterface['handleRedirectCallback'],
} as unknown as Auth0ContextInterface;

export const DevAuth0Provider = ({ children }: PropsWithChildren) => {
  return <Auth0Context.Provider value={mockAuth0Context}>{children}</Auth0Context.Provider>;
};
